import { useMemo } from 'react';

function setRef(ref, value) {
    if (typeof ref === "function") {
        ref(value);
    }
    else if (ref !== null && ref !== undefined) {
        ref.current = value;
    }
}
/**
 * useMergeRefs
 * Merges multiple refs into a single function ref.
 * Takes any number of refs.
 * Refs can be mutable refs or function refs.
 *
 * @param refs
 * @see https://rooks.vercel.app/docs/useMergeRefs
 */
function useMergeRefs(...refs) {
    return useMemo(() => {
        if (refs.every((ref) => ref === null)) {
            return null;
        }
        return (refValue) => {
            for (const ref of refs) {
                setRef(ref, refValue);
            }
        };
    }, [refs]);
}

export { useMergeRefs };
